var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row percentage-cardboxes"},_vm._l((_vm.stats),function(stat){return (_vm.organization_id)?_c('stat-card',{key:stat.id,attrs:{"organization":_vm.organization_id,"stat":stat}}):_vm._e()}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }